import { render } from "./MultiDiskSelection.vue?vue&type=template&id=4063112c&scoped=true"
import script from "./MultiDiskSelection.vue?vue&type=script&lang=js"
export * from "./MultiDiskSelection.vue?vue&type=script&lang=js"

import "./MultiDiskSelection.vue?vue&type=style&index=0&id=4063112c&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063112c"]])

export default __exports__